export const FAQ_CLUSTERS = [
  {
    id: 'services',
    title: 'Services',
    items: [
      {
        question: 'What is Skyline VFX?',
        answer:
          'Skyline VFX is the portfolio site of Lee Munday, a digital matte painter and concept artist for film and television VFX.',
      },
      {
        question: 'What services do you offer?',
        answer:
          'Digital matte painting, environment design, concept art, set extensions, and 2.5D projection / camera mapping for VFX.',
      },
      {
        question: 'What types of projects do you work on?',
        answer:
          'Film and television VFX projects that need photoreal environments, set extensions, and concept development for environments.',
      },
    ],
  },
  {
    id: 'workflow',
    title: 'Workflow',
    items: [
      {
        question: 'What deliverables can you provide?',
        answer:
          'Deliverables depend on the project, but typically include layered matte paintings, projection-ready assets, and final comp plates as agreed with production.',
      },
      {
        question: 'What software do you use?',
        answer:
          'Tools vary by project. Common tools include Photoshop, Nuke, Maya/Blender, After Effects, and Unreal Engine.',
      },
    ],
  },
  {
    id: 'availability',
    title: 'Availability and contact',
    items: [
      {
        question: 'Are you available for freelance work?',
        answer: 'Yes — availability varies. The best way to confirm is to email with dates and scope.',
      },
      {
        question: 'How do I contact you?',
        answer: 'Email: lmatthews@skylinevfx.com',
      },
    ],
  },
];

export const FAQS = FAQ_CLUSTERS.flatMap((c) => c.items);

function buildFaqSchemaItems(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };
}

export function getFaqPageSchema() {
  return buildFaqSchemaItems(FAQS);
}

